import UserDataService from '../../../../Shared/Assets/userdata-service.js';
import {empty} from '../../../../Shared/Assets/utils';

export default class DistanceCalculator {
    constructor() {
        this._handleSubmit = this._handleSubmit.bind(this);
        this._handleSuccessResponse = this._handleSuccessResponse.bind(this);
        this._clearErrorMessage = this._clearErrorMessage.bind(this);
    }

    init(formElement) {
        this.formElement = formElement;
        formElement.addEventListener('submit', this._handleSubmit);
        formElement.Postcode.addEventListener("input", () => {
            this._clearErrorMessage();
        });
    }

    _handleSubmit(evt) {
        evt.preventDefault();
        let form = evt.target;
        let button = form.btnSubmit;
        let action = form.action;
        let data = {
            NetworkId: form.NetworkId.value,
            Postcode: form.Postcode.value
        };

        this._clearErrorMessage();
        if (!this._validateSubmissionData(data)) {
            return false;
        }   

        button.disabled = true;
        form.classList.add("loading");

        $.post(action, data)
            .done(response => {
                button.disabled = false;
                form.classList.remove("loading");
                this._handleSuccessResponse(response);
            })
            .fail(errorResponse => {
                console.log(errorResponse);
                button.disabled = false;
                form.classList.remove("loading");
                this._displayError(errorResponse);
            });

        return false;
    }

    _handleSuccessResponse(response) {
        if (!response) return;

        if (response.distanceFromMeDisplay) {
            let distanceFromMeDisplayElms = document.getElementsByClassName("distance-from-me-display");
            if (distanceFromMeDisplayElms && distanceFromMeDisplayElms.length > 0) {
                for (var i = 0; i < distanceFromMeDisplayElms.length; i++) {
                    distanceFromMeDisplayElms[i].innerHTML = response.distanceFromMeDisplay;
                }
            }
        }

        // handle cookie data
        if (response.userData) {
            var userDataService = new UserDataService();
            userDataService.saveData(response.userData);
        }

        $("#postcode-entry-form").modal('hide');
    }

    _validateSubmissionData(data) {
        let errors = [];
        if (empty(data.NetworkId)) {
            errors.push("Network id is required.");
        }
        if (empty(data.Postcode)) {
            errors.push("Please enter postcode");
        }
        else if (isNaN(data.Postcode) || data.Postcode.length != 4) {
            errors.push("Postcode value is invalid. Please enter 4 digit postcode number");
        }

        if (!empty(errors)) {
            $("#validation-message")
                .html(errors.join("; "))
                .show();
            return false;
        }

        return true;
    }

    _clearErrorMessage() {
        $("#validation-message")
            .html("")
            .hide();
    }

    _displayError(error) {
        let errorMessage = "";
        let errorJson = error.responseJSON;
        if (!errorJson && error.responseText) {
            errorJson = JSON.parse(error.responseText);
        }

        if (typeof errorJson !== "undefined" && !empty(errorJson)) {
            let errorMessageList = new Array();
            for (let errorItem of errorJson.errors) {
                errorMessageList.push(errorItem.message);
            }

            errorMessage = errorMessageList.join(",");;
        }
        else {
            errorMessage = "Oops! There was an error when getting distance. Please try it again.";
            console.log(error);
        }

        $("#validation-message")
            .html(errorMessage)
            .show();
    }
}